<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Acknowledgements"><div class="titlepage"><div><div><h1 class="title"><a id="d0e67" xmlns:saxon="http://icl.com/saxon">Acknowledgements </a></h1></div></div></div><p><a id="d0e67" xmlns:saxon="http://icl.com/saxon">
</a></p><p><a id="d0e67" xmlns:saxon="http://icl.com/saxon">I want to thank Clare Pelino, my agent, for her hard work and kind personality, and
        Suzanne Gibbs Taylor, editorial vice president of Gibbs Smith, Publisher, who took a chance
        with this book. Hollie Keith, my editor, asked several important questions that made this a
        better cookbook. My friend Marlys Connor spent many days testing marshmallow recipes at
        varying high altitudes, and I truly appreciate her hard work and advice. Courtney Winston,
        the photographer, and Dan Macey, the food stylist, composed and shot handsome photos for the
        book, and were genuinely fun to work with. And, of course, I cannot forget my family and
        friends, especially Corinne and Arnold Johnson, and Anne Galbally and her beautiful
        daughters and sweet husband, who ate enough marshmallows to feed an army, or maybe two.
        Thank you all for helping to make this book possible.</a></p><div class="mediaobject" title="Photo of brownies."><a id="d0e67" xmlns:saxon="http://icl.com/saxon"><img alt="Photo of brownies." src="images/070403_brownies_0003.jpg"/></a></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?3e648364